import store from "../store";

import italian from "./italiano.json";
import spanish from "./spanish.json";
import english from "./english.json";
import romanian from "./romanian.json";
import french from "./french.json";
import german from "./german.json";

export enum Langs {
  It = "it",
  Es = "es",
  Uk = "uk",
  Ro = "ro",
  Fr = "fr",
  De = "de",
}

const messages = {
  [Langs.It]: italian,
  [Langs.Es]: spanish,
  [Langs.Ro]: romanian,
  [Langs.Uk]: english,
  [Langs.De]: german,
  [Langs.Fr]: french,
};

export const translate = (key: string): string => {
  let lang = "";
  if (store) {
    // @ts-ignore
    lang = store.getState().languageSelector.language || "it";
  } else {
    lang = localStorage.getItem("lang") || "it";
  }
  return messages[lang][key] || messages.it[key] || "N/A";
};
